"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.groupSurcharges = exports.arrayToObject = void 0;
exports.parseDeliveryAddress = parseDeliveryAddress;
exports.toCamelCaseString = exports.removeDuplicates = void 0;
var _lodash = require("lodash");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var removeDuplicates = exports.removeDuplicates = function removeDuplicates(array) {
  return _toConsumableArray(new Set(array));
};
var toCamelCaseString = exports.toCamelCaseString = function toCamelCaseString(value) {
  if (!(0, _lodash.isString)(value)) {
    return value;
  }
  return value.replace(/-([a-z])/g, function (match) {
    return match[1].toUpperCase();
  });
};

/* Parse delivery address and generate a legible label for displays. */
function parseDeliveryAddress(deliveryAddress, countryName, countryCodeAlpha3) {
  if (!deliveryAddress) {
    return null;
  }
  var address = deliveryAddress.address.replace(", ".concat(countryName, ", ").concat(countryCodeAlpha3), "");
  var deliveryAddressData = {
    address: address,
    postcode: deliveryAddress.postcode,
    floorUnit: deliveryAddress.floorUnit,
    buildingName: deliveryAddress.building,
    deliveryInstructions: deliveryAddress.deliveryInstructions,
    streetName: deliveryAddress.streetName
  };
  return _objectSpread(_objectSpread({}, deliveryAddressData), {}, {
    name: (0, _lodash.without)([deliveryAddressData.floorUnit, deliveryAddressData.buildingName], null, undefined).join(", "),
    label: (0, _lodash.without)([deliveryAddressData.floorUnit, (0, _lodash.without)([deliveryAddressData.buildingName, deliveryAddressData.streetName, deliveryAddressData.postcode], null, undefined).join(", ")], null, undefined, "").join(", ")
  });
}

/* Group surcharges based on surchargeType */
var groupSurcharges = exports.groupSurcharges = function groupSurcharges(surcharges) {
  return (0, _lodash.chain)(surcharges).groupBy("surchargeType").mapKeys(function (value, key) {
    return toCamelCaseString(key);
  }).value();
};
var arrayToObject = exports.arrayToObject = function arrayToObject(array) {
  var newObj = {};
  array.forEach(function (newElem) {
    newObj = _objectSpread(_objectSpread({}, newObj), newElem);
  });
  return newObj;
};